/**
 * Quality level enum for audio compression/quality settings
 * Used across forms for voice synthesis (Prompts, Demo, etc.)
 */
const QualityEnum = {
  HIGH_QUALITY: "HIGH_QUALITY",
  URA: "URA",
  CCITT: "CCITT"
};

/**
 * Get label for quality enum value (for UI display)
 * @param {string} value - Quality enum value
 * @returns {string} - Localized label
 */
export const getQualityLabel = (value) => {
  const labels = {
    [QualityEnum.HIGH_QUALITY]: "Alta qualidade",
    [QualityEnum.URA]: "Telefonia (URA)",
    [QualityEnum.CCITT]: "Telefonia (CCITT)"
  };
  return labels[value] || value;
};

/**
 * Get all quality options for dropdowns
 * @returns {Array} - Array of {value, label} objects
 */
export const getQualityOptions = () => [
  { value: null, label: "Compressão" },
  { value: QualityEnum.HIGH_QUALITY, label: getQualityLabel(QualityEnum.HIGH_QUALITY) },
  { value: QualityEnum.URA, label: getQualityLabel(QualityEnum.URA) },
  { value: QualityEnum.CCITT, label: getQualityLabel(QualityEnum.CCITT) }
];

export default QualityEnum;
